import { render } from "./EditAppointmentDay.vue?vue&type=template&id=0d04ce10&scoped=true"
import script from "./EditAppointmentDay.vue?vue&type=script&lang=js"
export * from "./EditAppointmentDay.vue?vue&type=script&lang=js"

import "./EditAppointmentDay.vue?vue&type=style&index=0&id=0d04ce10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d04ce10"]])

export default __exports__